// extracted by mini-css-extract-plugin
export default {"module":"checkbox_module__69MV4","inverted":"checkbox_inverted__BBprZ"};